import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const INSURANCE_WORDS_ENUM = ['Primary', 'Secondary', 'Additional', 'Additional', 'Additional'];

const PatientCoverageDetails = ({ webpageBase, patientCoverage, allowInsuranceCoverageData }) => (
  <div>
    {patientCoverage.isSelfPay && (
      <div>
        <div>Insurance: Self Pay</div>
      </div>
    )}
    {patientCoverage.insuranceCoverages.map((coverage, idx) => (
      <div key={coverage.id}>
        <div>
          {INSURANCE_WORDS_ENUM[idx]} Insurance: {coverage.displayName}
        </div>
        <div>
          Membership ID: {coverage.membershipIdCode}{' '}
          {allowInsuranceCoverageData && (
            <Link to={`${webpageBase}/insurance_coverages/${coverage.id}`}>(see details)</Link>
          )}
        </div>
      </div>
    ))}
  </div>
);

PatientCoverageDetails.propTypes = {
  patientCoverage: PropTypes.object.isRequired,
  allowInsuranceCoverageData: PropTypes.bool.isRequired,
  webpageBase: PropTypes.string,
};

export default PatientCoverageDetails;
